/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'
import * as ConvoDefs from '../../../chat/bsky/convo/defs.defs'

const $nsid = 'tools.ozone.inbox.listReports'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  did: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  filter: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.enum(['all', 'pending', 'resolved', 'unread']),
      'all',
    ),
  ),
  sortField: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.enum(['createdAt', 'updatedAt']),
      'updatedAt',
    ),
  ),
  sortDirection: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.enum(['asc', 'desc']), 'desc'),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  reports: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ReportView>((() => reportView) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** List moderation reports submitted by the authenticated account to this moderation service. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type ReportView = {
  $type?: 'tools.ozone.inbox.listReports#reportView'

  /**
   * Report ID (report table ID), used by getReport and Ozone's report detail page.
   */
  id: number

  /**
   * DID of the moderation service that received the report.
   */
  src: l.DidString
  scope?: 'network' | 'app' | 'labelOnly' | l.UnknownString
  isRead: boolean
  reason?: string
  status: 'pending' | 'resolved' | l.UnknownString
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.$Typed<ConvoDefs.MessageRef>
    | l.$Typed<ConvoDefs.ConvoRef>
    | l.Unknown$TypedObject
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString

  /**
   * The exact fully-qualified reason NSID submitted with and stored on the report.
   */
  reasonType: string

  /**
   * Public action associated with this report's transition to resolved. See the public action vocabulary table.
   */
  lastActionTaken?: string
}

export type { ReportView }

const reportView = /*#__PURE__*/ l.typedObject<ReportView>(
  $nsid,
  'reportView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    src: /*#__PURE__*/ l.string({ format: 'did' }),
    scope: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['network', 'app', 'labelOnly']
      }>(),
    ),
    isRead: /*#__PURE__*/ l.boolean(),
    reason: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 20000, maxGraphemes: 2000 }),
    ),
    status: /*#__PURE__*/ l.string<{ knownValues: ['pending', 'resolved'] }>(),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
          (() => AdminDefs.repoRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
          (() => RepoStrongRef.main) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.MessageRef>(
          (() => ConvoDefs.messageRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.ConvoRef>(
          (() => ConvoDefs.convoRef) as any,
        ),
      ],
      false,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    reasonType: /*#__PURE__*/ l.string(),
    lastActionTaken: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { reportView }
